<template>
    <view class="container" v-if="step == 1">

        <text class="title">选择标签，我来润色</text>
        <view class="tagList">
            <view class="tagList">
                <div v-for="(item, index) in pyq_config.tagList" :key="index" class="tag"
                    :class="{ active: isSelected(item) }" @click="toggleSelection(item)">
                    {{ item }}
                </div>
            </view>
        </view>
        <view class="card_list">
            <view class="card">


                <input :value="keyWords" class="t-input" name="" type="text" placeholder="自定义输入" />

            </view>

        </view>
        <view class="bottomBox"> <button @click="doGenerateContent">帮我润色</button></view>

    </view>

    <view class="container" v-else>

        <view class="picList">
            <view class="picList_item" v-for="(item, index) in pyq_config.picList" :key="index">
                <a @click.prevent="downloadImage(item.url, `image-${index}.jpg`)">
                    <img :src="item.url" alt="">
                </a>
            </view>

        </view>

        <view class="card_list">
            <view class="card">


                <textarea :value="aiContent" class="t-input2" name="" type="text" placeholder="正在生成中..." />

            </view>
            {{ consoleInfo }}
            <view class="someBtnBox" @click="reGenerate">
                <button class="reBtn">重新生成</button>
            </view>
        </view>

        <view class="bottomBox"> <button @click="doCopyToPengYouQuan">复制到微信发布</button></view>
    </view>
</template>

<script>
import {
    ref,
    getCurrentInstance,
    onMounted,
    reactive
} from 'vue'

export default {
    name: 'MyComponent',
    setup() {

        const { proxy } = getCurrentInstance();
        const shop_Id = ref('1b9686ec67fb66a10105d0836028b2ea');
        const app = proxy.$cloudbase; // Optional chaining to safely access $cloudbase
        const auth = proxy.$auth;
        const keyWords = ref('');
        const pyq_config = reactive({ tagList: [] });
        const step = ref(1);

        const consoleInfo = ref('');
        const aiContent = ref('');
        const selectedTags = ref([]);
        const reGenerate = () => {
            step.value = 1;
            aiContent.value = '';

        };

        /**
        * 判断给定标签是否被选中
        *
        * @param tag 要判断的标签
        * @returns 如果标签在选中标签集合中，则返回true，否则返回false
        */
        const isSelected = (tag) => {
            return selectedTags.value.includes(tag);
        };

        const toggleSelection = (tag) => {
            const index = selectedTags.value.indexOf(tag);
            if (index > -1) {
                selectedTags.value.splice(index, 1); // 移除
            } else {
                selectedTags.value.push(tag); // 添加
            }
        };

        const doGenerateContent = async () => {
            try {
                step.value = 2;
                const ai = app.ai();

                const tags = selectedTags.value.filter(Boolean).join(',');
                const customInput = keyWords.value.trim();
                const prompt = [tags, customInput].filter(Boolean).join(',');

                const res = await ai.bot.sendMessage({
                    botId: "bot-44201157",
                    msg: `我要给它种草，特点有${prompt}请帮我写一段文案，字数控制在100字以内。文案要朴实，简洁`
                });

                let resultString = '';
                for await (let text of res.textStream) {
                    resultString += text;
                }
                aiContent.value = resultString;
            } catch (error) {
                console.error('生成内容失败:', error);
                step.value = 1;
                consoleInfo.value = '生成失败，请重试';
            }
        }



        const downloadImage = (url, filename) => {
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            link.click();
        };

        const loadShopConfig = async () => {
            await auth.signInAnonymously();
            const db = app.database();
            const shopId = shop_Id.value;
            db.collection('my_peng_config').where({ shopId, deleted: 0, type: 'pyq' }).get().then(res => {

                Object.keys(res.data[0]).forEach((key) => {
                    console.log(key);
                    pyq_config[key] = res.data[0][key];
                });

                console.log(res.data[0], pyq_config, 'pyq_config');
            }).catch(err => {
                console.log(err);
            })

        }
        const doCopyToPengYouQuan = () => {



            var e = document.createElement("textarea");
            e.setAttribute("readonly", "readonly"),
                e.value = aiContent.value,
                document.body.appendChild(e),
                e.select();
            try {
                document.execCommand("copy")

                window.location = 'weixin://';
            } catch (t) {
                consoleInfo.value = '复制失败，请手动复制文案到朋友圈发布';

            } finally {
                document.body.removeChild(e)
            }
        }

        onMounted(async () => {



            loadShopConfig();
        }); // Moved onMounted inside the return statement for better readability and to ensure it's always called

        return { consoleInfo, doCopyToPengYouQuan, downloadImage, reGenerate, step, pyq_config, keyWords, doGenerateContent, aiContent, isSelected, toggleSelection }; // Including app in the return if it's intended to be used in the template
    }
}
</script>

<style scoped>
/* 基础样式变量 */

/* 容器样式 */
.container {

    background-color: rgb(245, 245, 247);
    min-height: 98vh;
    box-sizing: border-box;
    padding: 0;
    margin: 0;

    padding-top: 6vh;

    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;



}




/* 标题样式 */
.title {

    width: 80vw;
    height: 40px;
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 32px;
    line-height: 39px;
    text-align: center;
    padding: 9vw 0;



}

.tagList {
    margin: 3vh auto;
}

/* 卡片样式 */
.card {
    width: 90vw;

    margin-bottom: 20px;
    display: flex;
    align-items: center;

    background-color: rgb(255, 255, 255);
    box-sizing: border-box;
    color: rgb(0, 0, 0);
    display: flex;
    font-family: "PingFang SC";

    line-height: 24px;
    overflow-x: hidden;
    overflow-y: hidden;
    padding: 10px;
    position: relative;
    border-radius: 4px;

}

.t-cell__right-icon {
    position: absolute;
    right: 5vw;
    top: 42%;
}

/* 图标背景 */
.icon-bg {
    width: 48px;
    height: 48px;

    border-radius: 4px;
    margin-right: 15px;
}

.icon-bg img {
    width: 48px;
    height: 48px;
}

.card .t-input {
    display: block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    min-height: 24px;
    margin: 0;
    padding: 0;
    border: 0;
    outline: none;
    font-size: 1.2rem;
}

.card .right-part {
    height: 54px;
    display: flex;
    line-height: 24px;
    flex-direction: column;
    justify-content: space-between;
}

/* 卡片标题 */
.card-title {
    font-family: 'Inter', sans-serif;

    font-size: 16px;
    font-weight: 400;
    height: 24px;
    line-height: 24px;

}

/* 卡片副标题 */
.card-subtitle {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    height: 22px;
    line-height: 22px;
    margin-top: 4px;


}

.bottomBox {
    position: fixed;
    bottom: 5vh;
    width: 100vw;
    display: flex;
    justify-content: center;
}

.bottomBox button {
    display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    position: relative;
    white-space: nowrap;
    text-align: center;
    border: none;
    background-image: none;
    -webkit-transition: all .3s;
    transition: all .3s;
    border-radius: 6px;
    outline: none;
    font-family: PingFang SC, Microsoft YaHei, Arial Regular;
    font-weight: var(--td-button-font-weight, 600);
    vertical-align: top;
    cursor: pointer;
    color: white;
    background-color: rgb(0, 82, 217);
    height: 48px;
    line-height: 48px;
    font-size: 16px;
    width: 60vw;
}

.tag {
    display: inline-block;
    padding: 6px 12px;
    margin: 4px;

    border-radius: 20px;
    background-color: white;
    color: #333;
    cursor: pointer;
    transition: all 0.2s ease;
}

.tag.active {
    background-color: #0052d9;
    color: white;

}

.t-input2 {
    display: block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    min-height: 24px;
    margin: 0;
    padding: 8px;
    border: 0;
    outline: none;
    font-size: 1.2rem;
    height: 240px;
    /* 大约10行的高度 */
    resize: vertical;
    /* 允许用户垂直调整大小 */
    line-height: 1.5;
    /* 设置行高 */
}

.someBtnBox {
    display: flex;
    justify-content: flex-end;
    width: 90vw;
    margin-bottom: 5vh;
}

.reBtn {
    padding: 6px 12px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    background-color: #f0f0f0;
    color: #333;
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    border-radius: 4px;
    cursor: pointer;

}

.picList {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px;
    width: 90vw;
    margin-top: 3vh;
    margin-bottom: 20px;
}

.picList_item {
    aspect-ratio: 1/1;
    /* 保持正方形 */
    overflow: hidden;
    border-radius: 8px;
}

.picList_item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>
